<pm-toast ShowToast="ShowToast" 
    (OnClosed)="Close(undefined)">
    <div class="layout-center">
        <div class="toast-content-section">
            <div class="toast-header">{{Name}}</div>
            <div class="control-overflow-hidden">{{Message}}</div>
        </div>
        <pm-button *ngIf="Stack" (click)="CopyToClipBoard()" ButtonClass="button-link">Copy</pm-button>
    </div>
</pm-toast>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/services/logging/error-toast.html